module.exports = __webpack_public_path__ + "static/media/solarwinds-logo.283c9ca3.svg";